import React from 'react';
import { Alert } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';
import { TYPE } from '@kontentino/kontentino-constants/Pages';
import { modalRoutes } from 'constants/routes';
import { UserPermission } from 'constants/userPermission';
import { useUserPermissions } from 'app/hooks/useUserPermissions';
import { useSocialLoginContext } from 'app/modules/socialLogin/context';
import { addQueryParams } from 'utils/url';
import type { InstagramAudioErrorCode } from '../types';

interface InstagramAudioConnectProfileNoticeProps {
  pageId: number;
  errorCode?: InstagramAudioErrorCode | null;
}

const InstagramAudioConnectProfileNotice = ({
  pageId,
  errorCode,
}: InstagramAudioConnectProfileNoticeProps) => {
  const { t } = useTranslation();
  const socialLogin = useSocialLoginContext();
  const userPermissions = useUserPermissions();

  const handleConnectProfile = () =>
    socialLogin.authorize({
      pageId,
      pageType: TYPE.INSTAGRAM,
      redirectUrl: `${addQueryParams(window.location.href, {
        id: pageId,
        type: TYPE.INSTAGRAM,
      })}#${modalRoutes.ASSOCIATE_POSTS_PROFILE}`,
    });

  return (
    <Alert
      variant="warning"
      cta={
        userPermissions.hasEvery(UserPermission.PAGE_CREATE)
          ? {
              label: t('connectYourProfileCta'),
              onClick: handleConnectProfile,
              position: 'bottom',
            }
          : undefined
      }
      data-cy="instagram-audio_connect-profile-notice"
    >
      {errorCode === 'not_business_account'
        ? t('instagramAudio.businessAccountNotice')
        : t('instagramAudio.connectProfileNotice')}
    </Alert>
  );
};

export default InstagramAudioConnectProfileNotice;
